import { Tag } from '@vtbhome/juicyfront';
import { styled } from 'goober';
import { ReactNode } from 'react';
import { COLORS } from '@shared/config/colors/colors';
import { Colors } from '@shared/config/colors/types';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const Wrapper = styled(LinkScroll)<{ $isShowBorder: boolean }>`
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    overflow: hidden;
    background-color: ${COLORS.neutral_00};
    ${({ $isShowBorder }) => $isShowBorder && `border: 1px solid ${COLORS.neutral_20}`};
`;

export const Header = styled('div')<{ $bgColor: Colors }>`
    position: relative;
    display: flex;
    background-color: ${({ $bgColor }) => COLORS[$bgColor]};
    justify-content: space-between;
    flex-direction: column;
    overflow: hidden;
`;

export const TagsWrapper = styled('div')`
    position: absolute;
    display: flex;
    left: 20px;
    bottom: 20px;
`;

export const Content = styled('div')`
    display: flex;
    padding: 20px;
    gap: 8px;
    flex-direction: column;
`;

export const StyledTag = styled(Tag)<{ children: ReactNode }>`
    color: ${COLORS.neutral_90} !important;
    background: ${COLORS.neutral_10};

    .rf-tag__icon {
        display: flex;
        align-items: center;
    }
`;
